<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_v"></a><span class="small">CONTENTS</span></h2>
<p class="tocchapa"><a class="nounder" href="#/xhtml/ack"><em>Acknowledgments</em></a></p>
<p class="tocchapa"><a class="nounder" href="#/xhtml/intro">Introduction: Intimate Investments</a></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch01" title="Link target outside of Sample">1 Enforcing Romantic Love through Immigration Law</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch02" title="Link target outside of Sample">2 Conversions of the Self: Mexican Women’s Turn from the National to the Foreign</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch03" title="Link target outside of Sample">3 Outsourcing the American Dream: Transforming Men’s Virtual Fantasies into Social Realities</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch04" title="Link target outside of Sample">4 Bodies for Export! The Pliable Economy of Beauty and Passion in Colombia</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch05" title="Link target outside of Sample">5 Migrant Critique: Love and the Patriot</span></p>
<p class="tocchapa"><span class="nounder" href="#/xhtml/notes" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="tocchapa"><span class="nounder" href="#/xhtml/ref" title="Link target outside of Sample"><em>References</em></span></p>
<p class="tocchapa"><span class="nounder" href="#/xhtml/index" title="Link target outside of Sample"><em>Index</em></span></p>
<p class="tocchapa"><span class="nounder" href="#/xhtml/author" title="Link target outside of Sample"><em>About the Author</em></span><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?6b494f21